import { Grid, List, ListItemButton, ListItemText, ListSubheader, Typography } from "@mui/material";
import { useQuery } from "@tanstack/react-query";
import { Link as RouterLink, useParams } from "react-router-dom";

import { api } from "../api/client";
import { LoadingState } from "../components";
import { Markdown } from "../marketing/Markdown";
import { Section, Seo } from "../marketing/MarketingLayout";

type Index = { slug: string; title: string; section: string }[];

export function DocsPage() {
  const { "*": slug = "" } = useParams();
  const index = useQuery({ queryKey: ["docs-index"], queryFn: async () => ((await api.GET("/api/v1/website/docs/")).data ?? []) as unknown as Index });
  const page = useQuery({ queryKey: ["docs", slug], enabled: !!slug, queryFn: async () => (await api.GET("/api/v1/website/docs/{slug}/", { params: { path: { slug } } })).data as unknown as { title: string; body_markdown: string } | undefined });
  const sections = new Map<string, Index>();
  index.data?.forEach((d) => sections.set(d.section, [...(sections.get(d.section) ?? []), d]));
  return (
    <Section>
      <Seo title={page.data?.title ?? "Documentation"} />
      <Grid container spacing={4}>
        <Grid size={{ xs: 12, md: 3 }}>
          <List dense sx={{ position: { md: "sticky" }, top: 80, maxHeight: "80vh", overflow: "auto" }}>
            {[...sections.entries()].map(([section, pages]) => (
              <li key={section}><ul style={{ padding: 0 }}>
                <ListSubheader disableSticky sx={{ textTransform: "capitalize" }}>{section}</ListSubheader>
                {pages.map((p) => <ListItemButton key={p.slug} component={RouterLink} to={`/docs/${p.slug}`} selected={p.slug === slug}><ListItemText primary={p.title} /></ListItemButton>)}
              </ul></li>
            ))}
          </List>
        </Grid>
        <Grid size={{ xs: 12, md: 9 }}>
          {!slug && <><Typography variant="h1" sx={{ fontSize: "2.4rem" }}>Documentation</Typography><Typography color="text.secondary">Pick a module on the left. Every page is generated from the product's own feature guides.</Typography></>}
          {page.isLoading && <LoadingState />}
          {page.data && <Markdown source={page.data.body_markdown} />}
          {slug && !page.isLoading && !page.data && <Typography>Page not found.</Typography>}
        </Grid>
      </Grid>
    </Section>
  );
}
